export default __webpack_public_path__ + "static/media/a' tuigsinn.104a2649.mp3";